import Form from "../components/form";

function Login() {
  return (
    <div className="login-body">
      <div className="login-container">
        <div className="form-container">
          <h1 className="login-hello-title">Hello</h1>
          <Form />
        </div>
      </div>
    </div>
  );
}

export default Login;
